var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('waterfall',{attrs:{"data":_vm.list,"width":_vm.itemWidth,"gutterWidth":_vm.gutterWidth},on:{"loadmore":_vm.loadmore}},_vm._l((_vm.list),function(item,index){return _c('div',{key:index},[_vm._t("default",null,{"item":item})],2)}),0),_c('div',{staticClass:"no-more"},[(_vm.noMore)?_c('van-divider',[_vm._v("没有更多了")]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }